var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalf2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5001 2.19224V1.69224L9.0001 1.69224C4.96436 1.69226 1.69273 4.9639 1.69273 8.99964C1.69273 13.0354 4.96436 16.307 9.00008 16.3071L9.5001 16.3071V15.8071V2.19224ZM1.55273 8.99964C1.55273 4.88657 4.88705 1.55225 9.00014 1.55225C13.1132 1.55225 16.4475 4.88656 16.4475 8.99964C16.4475 13.1127 13.1132 16.4471 9.00014 16.4471C4.88706 16.4471 1.55273 13.1127 1.55273 8.99964Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalf2);
export default __webpack_public_path__ + "static/media/half-2.4408a45d8a5b3b60a8b1ceb45c2b4f19.svg";
export { ForwardRef as ReactComponent };